import { render } from "./InformeInteraccionJuego.vue?vue&type=template&id=5ce2a98a&scoped=true"
import script from "./InformeInteraccionJuego.vue?vue&type=script&lang=js"
export * from "./InformeInteraccionJuego.vue?vue&type=script&lang=js"

import "./InformeInteraccionJuego.vue?vue&type=style&index=0&id=5ce2a98a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce2a98a"]])

export default __exports__